import React from "react";

const DragAndDropContext = React.createContext(undefined);

function DragAndDropContextProvider({ children, value }) {
  return (
    <DragAndDropContext.Provider value={value}>{children}</DragAndDropContext.Provider>
  );
}

function useDragAndDropContext() {
  const context = React.useContext(DragAndDropContext);
  if (context === undefined) {
    throw new Error("useDragAndDropContext must be used within a DragAndDropContext");
  }
  return context;
}
export default useDragAndDropContext;
export { DragAndDropContextProvider, useDragAndDropContext };